export function formatBillingPeriod(interval: 'month' | 'year'): string {
  return interval === 'month' ? 'Monthly' : 'Annual';
}

export function monthlyAmountFromInvoice(
  totalExcludingTaxCents: number,
  interval: 'month' | 'year',
) {
  const monthlyCents =
    interval === 'year' ? Math.round(totalExcludingTaxCents / 12) : totalExcludingTaxCents;

  return monthlyCents;
}

export function formatMoney(
  cents: number,
  currency: string = 'USD',
  stripZeros: boolean = true,
): string {
  const amountInDollars = cents / 100;
  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amountInDollars);

  if (stripZeros) {
    return formatted.replace(/\.00$/, '');
  }

  return formatted;
}

export function formatPercent(percent: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(percent / 100);
}
